export default __webpack_public_path__ + "static/media/GUP.ad8a4d4d.svg";